module.exports = "/_next/static/images/proces-installatie-108e379ed7d8e7915cd8f37905e24083.svg";